import React, { useState } from 'react';
import PlusPlanSVG from '@birdi/icons/plus-plan-2.svg';
import { PlanOption, PlanData, PaymentIntervalOption } from './plan-option';

interface PlusPlanOptionProps {
  product: PlanData | null | undefined;
  displayInterval: PaymentIntervalOption;
  currency: string;
}

export const PlusPlanOption = (props: PlusPlanOptionProps): JSX.Element => {
  const { product, displayInterval: initialInterval, currency } = props;

  const features = (interval: PaymentIntervalOption) => {
    const processingGP = (interval === 'monthly') ? 2 : 48;
    const period = (interval === 'monthly') ? 'month' : 'year';
    // Use the plan's price currency from Stripe, fallback to organisation currency
    const planCurrency = product?.prices?.[0]?.currency || currency;
    const pricePerGP = (planCurrency === 'usd') ? '$9 USD/GP' : '$12 AUD/GP';
    return [
      '1 users + 20 guest seats',
      '5 workspace + 100 GB storage',
      `${processingGP} GP processing incl./${period}`,
      `Extra processing PAYG - ${pricePerGP}`,
    ];
  };

  // Manage interval state locally
  const [localInterval, setLocalInterval] =
    useState<PaymentIntervalOption>(initialInterval);

  // Local handler for interval changes
  const handleLocalIntervalChange = (interval: PaymentIntervalOption) => {
    setLocalInterval(interval);
  };

  return (
    <PlanOption
      title="Plus"
      icon={PlusPlanSVG}
      subtitle="For sole traders"
      description="Core visualization tools & map sharing — built for solo professionals who want to centralize and streamline their geospatial work."
      headerText="With Plus you get:"
      features={features(localInterval) || []}
      themeColor="lightFlora"
      planData={product}
      displayInterval={localInterval}
      currency={currency}
      withHeader="Sole traders"
      showIntervalToggle={true}
      onIntervalChange={handleLocalIntervalChange}
    />
  );
};
